module.exports = "<span\r\n  style=\"cursor: default !important;\"\r\n  class=\"ico-check m-btn m-btn-circle m-btn-circle-x-small\"\r\n  [ngClass]=\"getIcon().color\">\r\n  <i [ngClass]=\"getIcon().ico\"></i>\r\n</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/grid-components/boolean-check-disabled/boolean-check-disabled.component.html
// module id = 2329
// module chunks = 66